import { LoginControllerApi, UserControllerApi } from "src/api/api";

export interface IAuthApiClients {
    auth: LoginControllerApi;
    user: UserControllerApi;
}
export class AuthApiClients {
    private static instance: IAuthApiClients;
  
    private constructor() {}
  
    static getInstance(basePath: string): IAuthApiClients {
      if (AuthApiClients.instance == null) {
        AuthApiClients.instance = {
          auth: new LoginControllerApi({
            basePath: basePath,
            isJsonMime() {
              return true;
            }
          }),
          user: new UserControllerApi({
            basePath: basePath,
            isJsonMime() {
              return true;
            }
          })
        };
      }
      return AuthApiClients.instance;
    }
  }
  
